<template>
<keep-alive>
    <div id="modal" class="modal_size lg_size">
        <a href="javascript:" class="ui_close" type="button" rel="modal:close" @click="$emit('close')"><span class="sr_only">popup close</span></a>
        <dl class="modal_content">
            <dt class="ellipsis maintit">
                <i>{{ title }}</i>
            </dt>
            <dd>
                <div class="view_cont">
                    <table class="data_table">
                        <colgroup>
                            <col width="25%">
                            <col width="30%">
                            <col width="15%">
                            <col width="*">
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="text_center">{{ $t('FIELD.USER.ACCOUNT.NO') }}</th>
                                <th class="text_center">{{ $t('FIELD.USER.ID') }}</th>
                                <th class="text_center">{{ $t('FIELD.GLOBAL.COUNT') }}</th>
                                <th class="text_center">{{ $t('FIELD.GLOBAL.LASTUPDATEDDATE') }}</th>
                            </tr>
                        </thead>
                        <tbody v-if="isLoading">
                            <tr v-for="asc in ascList">
                                <td class="text_center">{{asc.ACCOUNT_NO}}</td>
                                <td class="text_center">{{asc.LOGIN_ID}}</td>
                                <td class="text_center">{{asc.CNT}}</td>
                                <td class="text_center">{{asc.MAX_LOG_DT}}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text_center" colspan="4">{{ $t('MESSAGE.DATA.FIND.NODATA') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </dd>
            <!-- 200707수정(버튼 하단으로 이동) S -->
            <dd class="scroll_btm">
                <div class="btn_wrap topLine">
                    <div class="btn_right">
                        <a href="javascript:" class="btn_white" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CLOSE') }}</a>
                    </div>
                </div>
            </dd>
            <!-- 200707수정(버튼 하단으로 이동) E -->
        </dl>
    </div>
</keep-alive>
</template>
<script>
import Vue          from 'vue';
import qs           from 'query-string';
import axios        from 'axios';
import { SDLUtil }  from '@/utils';

const fetchAscList = form => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/ascListSearch.skp?`,
    qs.stringify(form),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'KnowledgeASCHitCountPopup',
    props: {
        title: {},
        boardId: {},
        knowledgeId: {}
    },
    data() {
        return {
            isLoading: false,
            ascList: []
        }
    },
    computed: {
        getKnowledgeId() {
            return this.knowledgeId;
        }
    },
    methods: {
        async initLoad() {
            const form = { KNOWLEDGE_ID : this.getKnowledgeId };
            return await fetchAscList(form);
        }
    },
    mounted() {
        this.initLoad()
            .then(res => {
                let result = res.data.result;
                Vue.$log.info('▶ KnowledgeASCHitCountPopup.vue ->', result, result.rowCount);
                if(result.rowCount > 0) {
                    this.isLoading = true;
                    this.ascList = result.rowData;

                } else {
                    this.isLoading = false;
                    this.ascList = [];
                }
            })
            .catch(err => {
                SDLUtil.errorAlert(err);
            });
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/popup/KnowledgeASCHitCountPopup.vue